import axios from "axios";

export default {
  async fetchWalletSummary({ commit }) {
    try {
      const response = await axios.get("international/wallet");
      commit("SET_WALLET_SUMMARY", response.data.feed);
      commit("SET_ERROR_MSG", "");
    } catch (error) {
      commit("SET_WALLET_SUMMARY", null);
      commit(
        "SET_ERROR_MSG",
        (error.response && error.response.data && error.response.data.message) || ""
      );
    }
  },

  async fetchShipments({ commit }, credentials = {}) {
    try {
      const response = await axios.get("international/shipments", {
        params: {
          status: credentials.status || undefined,
          page: credentials.page || 1,
          per_page: credentials.perPage || 10,
        },
      });
      commit("SET_SHIPMENTS", response.data.feed);
      commit("SET_SHIPMENTS_PAGINATION", response.data.pagination);
      commit("SET_ERROR_MSG", "");
    } catch (error) {
      commit("SET_SHIPMENTS", []);
      commit(
        "SET_ERROR_MSG",
        (error.response && error.response.data && error.response.data.message) || ""
      );
    }
  },

  async fetchShipmentDetails({ commit }, id) {
    try {
      const response = await axios.get(`international/shipments/${id}`);
      commit("SET_SHIPMENT_DETAIL", response.data.feed);
      commit("SET_ERROR_MSG", "");
    } catch (error) {
      commit("SET_SHIPMENT_DETAIL", null);
      commit(
        "SET_ERROR_MSG",
        (error.response && error.response.data && error.response.data.message) || ""
      );
    }
  },

  async fetchWalletMovements({ commit }, credentials = {}) {
    try {
      const response = await axios.get("international/wallet/movements", {
        params: {
          international_shipment_id: credentials.shipmentId || undefined,
          page: credentials.page || 1,
          per_page: credentials.perPage || 10,
        },
      });
      commit("SET_WALLET_MOVEMENTS", response.data.feed);
      commit("SET_WALLET_MOVEMENTS_PAGINATION", response.data.pagination);
      commit("SET_ERROR_MSG", "");
    } catch (error) {
      commit("SET_WALLET_MOVEMENTS", []);
      commit(
        "SET_ERROR_MSG",
        (error.response && error.response.data && error.response.data.message) || ""
      );
    }
  },
};
